import { OptionItemType } from '../types/type'
export const genderOptions: OptionItemType[] = [
  {
    name: '男',
    value: true
  },
  {
    name: '女',
    value: false
  }
]

export const whetherOnOptions: OptionItemType[] = [
  {
    name: '是',
    value: 0
  },
  {
    name: '否',
    value: 1
  }
]

export const checkUpdateOptions: OptionItemType[] = [
  {
    name: '待审核',
    value: 0
  },
  {
    name: '审核失败',
    value: 1
  },
  {
    name: '审核成功',
    value: 2
  }
]

export const enableOptions: OptionItemType[] = [
  {
    name: '启用',
    value: true
  },
  {
    name: '禁用',
    value: false
  }
]

export const userTypeOptions: OptionItemType[] = [
  {
    name: '管理员',
    value: 0
  }
]

export const statusOptions: OptionItemType[] = [
  {
    name: '（学校）新建',
    value: -400
  },
  {
    name: '提交至二级单位、科室',
    value: -300
  },
  {
    name: '（二级单位、科室）新建',
    value: -200
  },
  {
    name: '提交至办公室工作人员',
    value: -100
  },
  {
    name: '未签件办理',
    value: 0
  },
  {
    name: '提交至主任',
    value: 100
  },
  {
    name: '主任已查看',
    value: 110
  },
  {
    name: '提交至领导',
    value: 120
  },
  {
    name: '领导已查看',
    value: 130
  },
  {
    name: '成功结束',
    value: 200
  },
  {
    name: '退回修改',
    value: 400
  },
  {
    name: '失败结束',
    value: 500
  }
]

export const objectTypeOptions: OptionItemType[] = [
  {
    name: '组织',
    value: 0
  },
  {
    name: '个人',
    value: 1
  }
]

export const radiusOptions: OptionItemType[] = [
  {
    name: '10m',
    value: 10
  },
  {
    name: '20m',
    value: 20
  },
  {
    name: '30m',
    value: 30
  },
  {
    name: '40m',
    value: 40
  },
  {
    name: '50m',
    value: 50
  },
  {
    name: '60m',
    value: 60
  },
  {
    name: '70m',
    value: 70
  },
  {
    name: '80m',
    value: 80
  },
  {
    name: '90m',
    value: 90
  },
  {
    name: '100m',
    value: 100
  },
  {
    name: '200m',
    value: 200
  },
  {
    name: '300m',
    value: 300
  },
  {
    name: '400m',
    value: 400
  },
  {
    name: '500m',
    value: 500
  },
  {
    name: '1000m',
    value: 1000
  },
  {
    name: '1500m',
    value: 1500
  },
  {
    name: '2000m',
    value: 2000
  }
]

export const clockStateOptions: OptionItemType[] = [
  {
    name: '正常上班',
    value: 1
  },
  {
    name: '迟到',
    value: 2
  },
  {
    name: '早退',
    value: 3
  },
  {
    name: '正常下班',
    value: 4
  }
]

export const studentTypeForRSOptions: OptionItemType[] = [
  {
    name: '县内学生',
    value: 0
  },
  {
    name: '新生',
    value: 1
  }
]

export const studentStatusForRSOptions: OptionItemType[] = [
  {
    name: '待审核',
    value: 0
  },
  {
    name: '审核成功',
    value: 1
  },
  {
    name: '审核失败',
    value: 2
  }
]

// 幼儿园招生申请状态
export const statusForRSKKindergarten: OptionItemType[] = [
  {
    name: '初审待审核',
    value: 0
  },
  {
    name: '初审失败',
    value: 5
  },
  {
    name: '初审成功，待填宝宝入园档案',
    value: 9
  },
  {
    name: '入园档案待审核',
    value: 10
  },
  {
    name: '档案审核失败',
    value: 15
  },
  {
    name: '待面审',
    value: 20
  },
  {
    name: '面审失败',
    value: 25
  },
  {
    name: '待最终确认幼儿',
    value: 30
  },
  // {
  //     name: "待体检",
  //     value: 30
  // },
  // {
  //     name: "体检信息录入完成",
  //     value: 39
  // },
  // {
  //     name: "体检通过待缴费",
  //     value: 40
  // },
  // {
  //     name: "缴费完成",
  //     value: 49
  // },
  // {
  //     name: "已发放入学通知书",
  //     value: 50
  // },
  {
    name: '谢绝申请',
    value: 100
  },
  {
    name: '已最终确认幼儿',
    value: 130
  }
]

// 有无遗传病史:
export const haveGeneticDiseaseOptions: OptionItemType[] = [
  {
    name: '有',
    value: true
  },
  {
    name: '无',
    value: false
  }
]

const whetherOptions: OptionItemType[] = [
  {
    name: '是',
    value: true
  },
  {
    name: '否',
    value: false
  }
]

// 是否独生子女：
export const whetherOnlyChildOptions: OptionItemType[] = [...whetherOptions]

// 是否属于精准扶贫建档立卡户：
export const whetherPovertyReliefOptions: OptionItemType[] = [
  ...whetherOptions
]

// 是否上过幼儿园：
export const whetherHaveAttendedKindergartenOptions: OptionItemType[] = [
  ...whetherOptions
]

export const stuStageOptionsForRS: OptionItemType[] = [
  {
    name: '小学',
    value: 0
  },
  {
    name: '初中',
    value: 1
  }
]

// 报名状态：城区公办：
// 0:待审核 1:跨区待审核 5:驳回 10:最终通过 100:初审通过(补丁 +的状态)
export const applyStatusOptionsCommon: OptionItemType[] = [
  {
    name: '待审核',
    value: 0
  },
  // {
  //     name: "跨区待审核",
  //     value: 1
  // },
  {
    name: '审核通过，待发放录取通知书',
    value: 100
  },
  {
    name: '审核不通过，已驳回',
    value: 5
  },
  {
    name: '已发放通知书',
    value: 10
  }
]

// 私办：
// 0:待审核 1:跨区待审核 5:驳回 10:最终通过 100:初审通过(补丁 +的状态)
export const applyStatusOptionsPrivate: OptionItemType[] = [
  {
    name: '待审核',
    value: 0
  },
  {
    name: '审核通过，待发放录取通知书',
    value: 100
  },
  {
    name: '审核不通过，已驳回',
    value: 5
  },
  {
    name: '已发放通知书',
    value: 10
  }
]

// 报名状态tag：
export const applyStatusForTagOptions: OptionItemType[] = [
  {
    name: '',
    value: 0
  },
  {
    name: '',
    value: 1
  },
  {
    name: 'danger',
    value: 5
  },
  {
    name: 'success',
    value: 10
  }
]

// 项目工程模块：
export const EPMStatus: OptionItemType[] = [
  {
    name: '已创建',
    value: 1
  },
  {
    name: '已上报实施',
    value: 2
  },
  {
    name: '已通过初审',
    value: 3
  },
  {
    name: '已确定立项',
    value: 4
  },
  {
    name: '已归档',
    value: 5
  }
]

// 模块 0:默认 1:工程管理公告 2:工程政策文件 3:资助系统公告 4:资助系统政策文件
export const moduleTypeOptions: OptionItemType[] = [
  {
    name: '通知公告',
    value: 1
  },
  {
    name: '政策文件',
    value: 2
  }
]

export const moduleTypeOptionsForSM: OptionItemType[] = [
  {
    name: '通知公告',
    value: 3
  },
  {
    name: '政策文件',
    value: 4
  }
]

export const moneyTypeOptions: OptionItemType[] = [
  {
    name: '中央',
    value: 'centerFund'
  },
  {
    name: '省级',
    value: 'provinceFund'
  },
  {
    name: '县级',
    value: 'countyFund'
  },
  {
    name: '其他',
    value: 'otherFund'
  }
]

// 拨款申请状态 0:申请中 1:拒绝 2:同意 (后加) 3:初审同意 (后加) 4:初审拒绝
export const EPMStatusForLookInputFundingApplication: OptionItemType[] = [
  {
    name: '申请中',
    value: 0
  },
  {
    name: ' 终审拒绝',
    value: 1
  },
  {
    name: '终审同意',
    value: 2
  },
  {
    name: '初审同意',
    value: 3
  },
  {
    name: '初审拒绝',
    value: 4
  }
]

// 是否跨片区：
export const whetherHopeOptions: OptionItemType[] = [
  {
    name: '是',
    value: true
  },
  {
    name: '否',
    value: false
  },
  {
    name: '否',
    value: null
  }
]

// 资助模块：
// 0上级1本级2中心杂件
export const typeOfSMCenterFile: OptionItemType[] = [
  {
    name: '上级文件',
    value: 0
  },
  {
    name: '本级文件',
    value: 1
  },
  {
    name: '中心杂件',
    value: 2
  }
]

// 0资金文件录入1资助业务设置
export const typeOfSMSupportFile: OptionItemType[] = [
  {
    name: '资金文件',
    value: 0
  },
  {
    name: '资助业务',
    value: 1
  }
]

// 资助名称：
// 学前教育资助、
// 义务教育阶段家庭经济困难学生生活费补助（“一补”）、
// 普通高中国家助学金、
// 普通高中免学杂费、
// 中职国家助学金、
// 中职免学费、
// 中央专项彩票公益金滋蕙计划、
// 大学新生入学资助
// export const subsidizeNameOptions: OptionItemType[] = [
//     {
//         name: "学前教育资助",
//         value: 0
//     },
//     {
//         name: "义务教育阶段家庭经济困难学生生活费补助（“一补”）",
//         value: 1
//     },
//     {
//         name: "普通高中国家助学金",
//         value: 2
//     },
//     {
//         name: "普通高中免学杂费",
//         value: 3
//     },
//     {
//         name: "中职国家助学金",
//         value: 4
//     },
//     {
//         name: "中职免学费",
//         value: 5
//     },
//     {
//         name: "中央专项彩票公益金滋蕙计划",
//         value: 6
//     },
//     {
//         name: "大学新生入学资助",
//         value: 7
//     }
// ];

// 电子印章管理type: 0: 幼儿园老师 1: 班主任 2: 校长 3: 学校公章
export const typeOfElectronicSeal: OptionItemType[] = [
  {
    name: '幼儿园老师',
    value: 0
  },
  {
    name: '班主任',
    value: 1
  },
  {
    name: '校长',
    value: 2
  },
  {
    name: '学校公章',
    value: 3
  }
]

// 电子印章管理type: 0: 幼儿园老师 1: 班主任 2: 校长 3: 学校公章
export const typeOfElectronicSealForCounty: OptionItemType[] = [
  {
    name: '资助中心主任签字',
    value: 4
  },
  {
    name: '资助中心公章',
    value: 5
  }
]

// 资助学期:
export const sponsoredSemesterOptions: OptionItemType[] = [
  {
    name: '春季学期',
    value: 0
  },
  {
    name: '秋季学期',
    value: 1
  }
]

// 部门学期:
export const departmentalSemesterOptions: OptionItemType[] = [
  ...sponsoredSemesterOptions
]

// 资助申请类型 0:学前教育 1:困难生活费补 2:高中助学金 3:高中免学费 4:职校免学费 5:职校助学金 6:困难大学生 7:彩票公益
export const typeOfReviewOptions: OptionItemType[] = [
  {
    name: '学前教育资助',
    value: 0
  },
  {
    name: '义务教育阶段家庭经济困难学生生活费补助（“一补”）',
    value: 1
  },
  {
    name: '普通高中国家助学金',
    value: 2
  },
  {
    name: '普通高中免学杂费',
    value: 3
  },
  {
    name: '中职免学费',
    value: 4
  },
  {
    name: '中职国家助学金',
    value: 5
  },
  {
    name: '大学新生入学资助',
    value: 6
  },
  {
    name: '中央专项彩票公益金滋蕙计划',
    value: 7
  }
]

// 资助查询条件 4:学校初审失败(需要修改)  5:谢绝
// 10:学校初审待审核  11:学校初审失败  12:学校初审通过
// 20:学校待评审  21:学校评审失败  22:学校评审成功
// 30:乡镇待评审  31:乡镇评审失败  32:乡镇评审成功
// 40:县级待评审  41:县级评审失败 42:县级评审成功
export const typeOfAuditStatusOptions: OptionItemType[] = [
  {
    name: '退回修改',
    value: 4,
    tab: 1
  },
  {
    name: '谢绝',
    value: 5,
    tab: 1
  },
  {
    name: '初审待审核',
    value: 10,
    tab: 1
  },
  {
    name: '初审失败',
    value: 11,
    tab: 1
  },
  {
    name: '初审通过',
    value: 12,
    tab: 1
  },
  {
    name: '学校待评审',
    value: 20,
    tab: 2
  },
  {
    name: '学校评审失败',
    value: 21,
    tab: 2
  },
  {
    name: '学校评审通过',
    value: 22,
    tab: 2
  },

  {
    name: '乡镇待评审',
    value: 30,
    tab: 3
  },
  {
    name: '乡镇评审失败',
    value: 31,
    tab: 3
  },
  {
    name: '乡镇评审通过',
    value: 32,
    tab: 3
  },
  {
    name: '县级待评审',
    value: 40,
    tab: 4
  },
  {
    name: '县级评审失败',
    value: 41,
    tab: 4
  },
  {
    name: '县级评审通过',
    value: 42,
    tab: 4
  }
]

// 是否申请资助：
export const fundingApplicationOptions: OptionItemType[] = [
  {
    name: '未申请',
    value: 0
  },
  {
    name: '已申请',
    value: 1
  },
  {
    name: '已放弃',
    value: 2
  }
]

// 负面清单管理，是否
export const negativeListWhetherOptions: OptionItemType[] = [...whetherOptions]

// 负面清单管理性别
export const negativeGenderListOptions: OptionItemType[] = [...genderOptions]

// 户口：
export const registeredPermanentResidenceOptions: OptionItemType[] = [
  {
    value: 1,
    name: '城镇'
  },
  {
    value: 0,
    name: '农村'
  }
]

// 过程管理：
// 数据状态(0:待补充 10:校审核中 11:镇审核失败 20:镇审核中 21:县审核失败 30:县审核中 40:县级审核成功
export const courseManagementDataStatusOptions: OptionItemType[] = [
  {
    value: 0,
    name: '待补充'
  },
  {
    value: 10,
    name: '校审核中'
  },
  {
    value: 11,
    name: '镇审核失败'
  },
  {
    value: 20,
    name: '镇审核中'
  },
  {
    value: 21,
    name: '县审核失败'
  },
  {
    value: 30,
    name: '县审核中'
  },
  {
    value: 40,
    name: '县级审核成功'
  }
]
